import { gql } from '@apollo/client';

export const ADD_GRAPH_TO_DASHBOARD = gql`
  mutation AddGraphToDashboard($dashboardName: String!, $graph: String!, $tabName: String!) {
    addGraphToDashboard(dashboardName: $dashboardName, graph: $graph, tabName: $tabName) {
      graphs
    }
  }
`;

export const ADD_PQ_TO_DASHBOARD = gql`
  mutation AddPowerQueryToDashboard($dashboardName: String!, $graphName: String!, $query: String!, $tabName: String!) {
    savePowerQueryToDashboard(dashboardName: $dashboardName, graphName: $graphName, query: $query, tabName: $tabName) {
      graphs
    }
  }
`;

export const CREATE_DASHBOARD_V2 = gql`
  mutation CreateDashboard($dashboardName: String!) {
    createDashboardV2(dashboardName: $dashboardName) {
      name
    }
  }
`;

export const DELETE_DASHBOARD = gql`
  mutation DeleteDashboard($dashboardName: String!) {
    deleteDashboard(dashboardName: $dashboardName)
  }
`;

export const DELETE_DASHBOARD_GRAPH = gql`
  mutation DeleteDashboardGraph($dashboardName: String!, $graphIndex: Int!, $tabName: String!) {
    deleteDashboardGraph(dashboardName: $dashboardName, graphIndex: $graphIndex, tabName: $tabName) {
      graphs
    }
  }
`;

export const EDIT_DASHBOARD_GRAPH = gql`
  mutation EditDashboardGraph(
    $dashboardName: String!
    $graphIndex: Int!
    $graph: String!
    $layout: String
    $tabName: String!
  ) {
    editDashboardGraph(
      dashboardName: $dashboardName
      graphIndex: $graphIndex
      graph: $graph
      layout: $layout
      tabName: $tabName
    ) {
      graphs
    }
  }
`;

export const GET_CONFIGV2 = gql`
  query GetDashboardConfigV2($name: String!) {
    getDashboardV2(dashboardName: $name, resolveParameters: true) {
      name
      urlTemplate
      description
      configType
      duration
      firstTab {
        tabName
      }
      isBuiltIn
      tabs {
        tabName
        parameters
        graphs
        filters
        options
      }
    }
  }
`;

export const LIST_FULL_DASHBOARDS_V2 = gql`
  query ListFullDashboards {
    dashboardsV2 {
      name
      description
      configType
      tabs {
        parameters
        graphs
        filters
        options
        tabName
      }
    }
  }
`;

export const LIST_DASHBOARD_NAMES = gql`
  query GetDashboardNames {
    dashboardsV2 {
      name
    }
  }
`;

export const RENAME_DASHBOARD_V2 = gql`
  mutation RenameDashboardV2($dashboardName: String!, $name: String!, $description: String, $tabName: String) {
    editDashboardV2(dashboardName: $dashboardName, newName: $name, description: $description, tabName: $tabName) {
      name
      description
    }
  }
`;

export const SAVE_LAYOUT = gql`
  mutation SaveDashboardLayout($name: String!, $graphs: String, $options: String, $tabName: String) {
    saveDashboardLayout(dashboardName: $name, graphs: $graphs, options: $options, tabName: $tabName) {
      graphs
      options
    }
  }
`;

export const ADD_DASHBOARD_FILTER = gql`
  mutation AddDashboardFilter($dashboardName: String!, $filter: DashboardFilterInput!, $tabName: String!) {
    addDashboardFilter(dashboardName: $dashboardName, filter: $filter, tabName: $tabName) {
      filters
    }
  }
`;

export const EDIT_DASHBOARD_FILTER = gql`
  mutation EditDashboardFilter(
    $dashboardName: String!
    $filter: DashboardFilterInput!
    $filterIndex: Int!
    $tabName: String!
  ) {
    editDashboardFilter(dashboardName: $dashboardName, filter: $filter, filterIndex: $filterIndex, tabName: $tabName) {
      filters
    }
  }
`;

export const DELETE_DASHBOARD_FILTER = gql`
  mutation DeleteDashboardFilter($dashboardName: String!, $filterIndex: Int!, $tabName: String!) {
    deleteDashboardFilter(dashboardName: $dashboardName, filterIndex: $filterIndex, tabName: $tabName) {
      filters
    }
  }
`;

export const SAVE_DASHBOARD_TABS = gql`
  mutation arrangeTabsOrderAndNames($dashboardName: String!, $tabs: [DashboardTabNameInput]!) {
    arrangeTabsOrderAndNames(dashboardName: $dashboardName, tabs: $tabs)
  }
`;

export const MOVE_GRAPHS_BETWEEN_TABS = gql`
  mutation moveGraphBetweenDashboardTabs(
    $dashboardName: String!
    $destinationTabName: String!
    $graphIndex: Int!
    $sourceTabName: String!
  ) {
    moveGraphBetweenDashboardTabs(
      dashboardName: $dashboardName
      destinationTabName: $destinationTabName
      graphIndex: $graphIndex
      sourceTabName: $sourceTabName
    )
  }
`;
